import React from "react";
import { useNavigate } from "react-router-dom";
import { Menu, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const AdminTopbar = ({ onOpenSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="h-14 shrink-0 border-b border-celestial-border/15 bg-surface/40 backdrop-blur-sm flex items-center justify-between px-4 lg:px-6">
      <button
        onClick={onOpenSidebar}
        className="lg:hidden text-celestial-muted hover:text-celestial-text p-1.5 -ml-1.5"
        aria-label="Open sidebar"
      >
        <Menu className="w-5 h-5" />
      </button>
      <div className="hidden lg:block" />
      <button
        onClick={onLogout}
        className="text-xs text-celestial-muted hover:text-celestial-text flex items-center gap-1.5"
        data-testid="logout-button"
      >
        <LogOut className="w-3.5 h-3.5" /> {user?.email}
      </button>
    </header>
  );
};

export default AdminTopbar;
